import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=8d3a618c&scoped=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=8d3a618c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3a618c",
  null
  
)

export default component.exports